import React from 'react';
import useColors from 'ui/hooks/useColors';

const AISvg = ({ className }) => {
  const { colorPrimary } = useColors();

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75327 1.39939L5.47539 3.91365C5.60149 4.35057 5.92671 4.69237 6.34219 4.82437L8.73155 5.58563C8.88739 5.63522 8.9754 5.80828 8.92841 5.97213C8.89987 6.07144 8.82606 6.14924 8.73155 6.17928L6.34219 6.94054C5.92671 7.07254 5.60149 7.41434 5.47539 7.85126L4.75327 10.3655C4.70734 10.5298 4.54367 10.6239 4.38743 10.5756C4.29119 10.5458 4.21606 10.4666 4.18779 10.3655L3.46434 7.85126C3.33917 7.4142 3.01421 7.07226 2.59886 6.94054L0.209503 6.17928C0.0536641 6.12969 -0.0343439 5.95662 0.0126468 5.79278C0.0411864 5.69347 0.114991 5.61566 0.209503 5.58563L2.59886 4.82437C3.01421 4.69265 3.33917 4.35071 3.46434 3.91365L4.18779 1.39939C4.23372 1.23512 4.39739 1.14098 4.55362 1.18931C4.64973 1.21892 4.72499 1.29812 4.75327 1.39939Z"
        fill={colorPrimary}
      />
      <path
        d="M7.89803 10.6884L8.24009 11.8198C8.29982 12.0164 8.45387 12.1702 8.65068 12.2296L9.78248 12.5722C9.8563 12.5945 9.89799 12.6724 9.87573 12.7461C9.86221 12.7908 9.82725 12.8258 9.78248 12.8393L8.65068 13.1819C8.45387 13.2413 8.29982 13.3951 8.24009 13.5917L7.89803 14.7231C7.87628 14.7971 7.79875 14.8394 7.72474 14.8177C7.67915 14.8043 7.64357 14.7686 7.63017 14.7231L7.28749 13.5917C7.22819 13.395 7.07427 13.2412 6.87752 13.1819L5.74572 12.8393C5.6719 12.817 5.63022 12.7391 5.65247 12.6654C5.66599 12.6207 5.70095 12.5857 5.74572 12.5722L6.87752 12.2296C7.07427 12.1703 7.22819 12.0165 7.28749 11.8198L7.63017 10.6884C7.65193 10.6145 7.72946 10.5721 7.80346 10.5938C7.84899 10.6072 7.88464 10.6428 7.89803 10.6884Z"
        fill={colorPrimary}
      />
      <path
        d="M13.3551 5.54576L13.8112 7.05432C13.8908 7.31647 14.0962 7.52155 14.3586 7.60075L15.8677 8.05751C15.9661 8.08726 16.0217 8.1911 15.992 8.2894C15.974 8.34899 15.9274 8.39567 15.8677 8.41369L14.3586 8.87045C14.0962 8.94965 13.8908 9.15473 13.8112 9.41688L13.3551 10.9254C13.3261 11.024 13.2227 11.0805 13.124 11.0515C13.0633 11.0336 13.0158 10.9861 12.9979 10.9254L12.541 9.41688C12.462 9.15465 12.2567 8.94948 11.9944 8.87045L10.4853 8.41369C10.3869 8.38394 10.3313 8.2801 10.361 8.18179C10.379 8.12221 10.4257 8.07553 10.4853 8.05751L11.9944 7.60075C12.2567 7.52172 12.462 7.31655 12.541 7.05432L12.9979 5.54576C13.027 5.4472 13.1303 5.39072 13.229 5.41971C13.2897 5.43748 13.3372 5.485 13.3551 5.54576Z"
        fill={colorPrimary}
      />
    </svg>
  );
};

export default AISvg;
